function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(20262 -1816)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-20262 1816)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20256.789 1823.776)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4923.135,3453.113h10.782c.538,0,.538,0,.538-.521,0-3.548-.005-7.1.008-10.645,0-.36-.093-.46-.456-.459q-6.639.019-13.279,0c-.333,0-.465.076-.442.431.03.471.007.946.007,1.476-.219-.079-.387-.154-.563-.2-.535-.14-1.069-.292-1.612-.393-.221-.041-.308-.091-.3-.322.014-.486.005-.973,0-1.459a1.936,1.936,0,0,1,2.05-2.055q3.969-.007,7.938,0h6.942a2,2,0,0,1,2.21,2.2q.007,4.45,0,8.9c0,1.116,0,2.231,0,3.346a1.959,1.959,0,0,1-1.129,1.971,2.067,2.067,0,0,1-.823.18c-3.252.012-6.5.006-9.754.012a.473.473,0,0,1-.493-.306,6.018,6.018,0,0,0-1.467-1.9,2.259,2.259,0,0,0-.228-.156Z",
  transform: "translate(4934.881 -3438.964)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-5012.356,3643.9q-2.51,0-5.021,0a1.185,1.185,0,0,1-1.332-1.371,4.973,4.973,0,0,1,4.993-4.93c.949.013,1.9,0,2.848,0a4.975,4.975,0,0,1,4.9,5.224,1.134,1.134,0,0,1-1.229,1.073c-1.625,0-3.251,0-4.877,0Z",
  transform: "translate(5018.709 -3623.452)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-4978.8,3511.4a3.743,3.743,0,0,1,3.771,3.839,3.717,3.717,0,0,1-3.777,3.77,3.711,3.711,0,0,1-3.84-3.812A3.727,3.727,0,0,1-4978.8,3511.4Z",
  transform: "translate(4985.217 -3506.239)",
  fill: "currentColor",
  fillRule: "evenodd"
})));

function SvgIconDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.20847a9b.svg";
export { ForwardRef as ReactComponent };